var Config = function(alto, margen) {
  var ancho = 1000;
  var tamanioTipografia = 18;

  var margin = { top: 20, right: 30, bottom: 20, left: 30 };
  var medidas = {
    ancho: ancho - margin.left - margin.right,
    alto: alto - margin.top - margin.bottom
  };
  var gMargin = margen || { top: 80, right: 10, bottom: 60, left: 70 };
  var gMedidas = {
    ancho: medidas.ancho - gMargin.left - gMargin.right,
    alto: medidas.alto - gMargin.top - gMargin.bottom
  };

  var tooltip = { ancho: 200, alto: 150 };

  var estilos = {
    reticula: {
      stroke: "#cdcdcd",
      "stroke-width": "1px"
    },

    eje: {
      fill: "none",
      stroke: "none",
      "shape-rendering": "crispEdges"
    },

    etiquetaEjeX: {
      fill: "#000",
      "font-size": 0.6 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "middle",
      "font-weight": "400",
      "font-style": "normal"
    },

    etiquetaEjeY: {
      fill: "#000",
      "font-size": 0.6 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "end",
      "font-weight": "400",
      "font-style": "normal"
    },

    etiquetaEjeXSmall: {
      fill: "#000",
      "font-size": 0.4 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "middle",
      "font-weight": "400",
      "font-style": "normal"
    },

    barra: {
      fill: "#14c1b4"
    },

    valoresBarraVertical: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 1 * tamanioTipografia + "px",
      "font-weight": "500",
      "font-style": "normal",
      "dominant-baseline": "alphabetic",
      "text-anchor": "middle"
    },

    valoresBarraHorizontal: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 1 * tamanioTipografia + "px",
      "font-weight": "500",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "start"
    },

    leyendaEjeY: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "end"
    },

    leyendaEjeX: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "start"
    },

    titulo: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 1.1 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "alphabetical",
      "text-anchor": "start"
    },

    leyendaPromedioUnidad: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 1.3 * tamanioTipografia + "px",
      "font-weight": "500",
      "font-style": "normal",
      "dominant-baseline": "alphabetical",
      "text-anchor": "end"
    },

    leyendaPromedio: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#000000",
      "font-size": 1.1 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "alphabetical",
      "text-anchor": "end"
    }
  };

  var circulos = {
    radio: 50,
    offset: 30,
    distanciaHorizontal: 200,
    estiloCirculo: {
      stroke: "#14c1b4",
      "stroke-width": "2px",
      fill: "none"
    },
    estiloTexto: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 1.7 * tamanioTipografia + "px",
      "font-weight": "700",
      "dominant-baseline": "central",
      "text-anchor": "middle"
    },
    estiloSubTexto: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#000000",
      "font-size": 0.6 * tamanioTipografia + "px",
      "font-weight": "400",
      "dominant-baseline": "central",
      "text-anchor": "middle"
    },
    estiloLeyenda: {
      fill: "#000",
      "font-size": 0.6 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "middle",
      "font-weight": "400"
    },
    estiloLinea: {
      "stroke-width": "1px",
      stroke: "#14c1b4"
    }
  };

  var palabras = {
    distanciaVertical: 65,
    tamanio: {
      min: 1 * tamanioTipografia,
      max: 3 * tamanioTipografia
    },
    estiloEtiqueta: {
      fill: "#808080",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "start",
      "font-weight": "400",
      "dominant-baseline": "alphabetic"
    },
    estiloValor: {
      fill: "#14c1b4",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "start",
      "font-weight": "600",
      "dominant-baseline": "alphabetic"
    }
  };

  var barrasHorizontales = {
    distanciaVertical: 50,
    estiloNota: {
      fill: "#000",
      "font-size": 0.6 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "start",
      "font-weight": "400"
    },
    lineaVelocidad: {
      stroke: "#14c1b4",
      "stroke-width": "4px"
    },
    flechaVelocidad: {
      stroke: "#14c1b4",
      fill: "#14c1b4"
    },
    leyendaEmisiones: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.7 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "hanging",
      "text-anchor": "start"
    }
  };

  var tabla = {
    distanciaVertical: 8,
    fondo: "#14c1b4",
    estiloCabecera: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "start"
    },
    estiloNumeroCabecera: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "end"
    },
    estiloRenglon: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#000000",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "start"
    },
    estiloNumeroRenglon: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#000000",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "end"
    }
  };

  var transportes = { fondo: "#ababab" };

  var tablaAspectos = {
    fondo: "#14c1b4",
    paddingAspectosX: 20,
    paddingAspectosY: 10,
    estiloSeparador: {
      stroke: "#ababab",
      "stroke-width": "2px"
    },
    estiloCabecera: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#14c1b4",
      "font-size": 0.9 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "middle"
    },
    estiloRenglon: {
      "font-family": '"Montserrat", sans-serif',
      fill: "#000000",
      "font-size": 0.7 * tamanioTipografia + "px",
      "font-weight": "400",
      "font-style": "normal",
      "dominant-baseline": "central",
      "text-anchor": "start"
    }
  };

  var pastel = {
    "font-family": '"Montserrat", sans-serif',
    "font-size": 1.2 * tamanioTipografia + "px",
    "font-weight": "600",
    "font-style": "normal",
    "dominant-baseline": "hanging",
    "text-anchor": "end"
  };

  var mapa = {
    leyenda: {
      fill: "#000",
      "font-size": 0.8 * tamanioTipografia + "px",
      "font-family": '"Montserrat", sans-serif',
      "text-anchor": "start",
      "font-weight": "400",
      "font-style": "normal"
    }
  };

  var nube = {
    fuente: "Montserrat",
    familia: '"Montserrat", sans-serif',
    fill: "#14c1b4"
  };

  return {
    getAncho: function() {
      return ancho;
    },
    getMargin: function() {
      return margin;
    },
    getMedidas: function() {
      return medidas;
    },
    getGMargin: function() {
      return gMargin;
    },
    getGMedidas: function() {
      return gMedidas;
    },
    getTMedidas: function() {
      return tooltip;
    },
    getEstilos: function() {
      return estilos;
    },
    getCirculos: function() {
      return circulos;
    },
    getPalabras: function() {
      return palabras;
    },
    getBarrasHorizontales: function() {
      return barrasHorizontales;
    },
    getTabla: function() {
      return tabla;
    },
    getTransportes: function() {
      return transportes;
    },
    getTablaAspectos: function() {
      return tablaAspectos;
    },
    getPastel: function() {
      return pastel;
    },
    getMapa: function() {
      return mapa;
    },
    getNube: function() {
      return nube;
    }
  };
};
